import React, { useEffect, useState } from "react";
import numeral from "numeral";
import toastr from "toastr"
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Label,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Input,
  InputGroup,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import  { useHistory } from  'react-router-dom'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "../../axios"
//Import Product Images
import img1 from "../../assets/images/product/image23432.jpg";
import img2 from "../../assets/images/product/img-2.png";
import img3 from "../../assets/images/product/img-3.png";
import img4 from "../../assets/images/product/img-4.png";
import img5 from "../../assets/images/product/img-5.png";
import img6 from "../../assets/images/product/img-6.png";
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
import DeleteModal from "../../components/Common/DeleteModal"
import '../../NumberInput.css'
import { set } from "lodash";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const productListvar = [
  {
    id: 1,
    img: img1,
    name: "Rounded Earrings",
    color: "Maroon",
    price: "450",
    data_attr: 2,
    total: 900,
  },
  
];


const EcommerceCart = (props) => {
  const [productList, setproductList] = useState(productListvar);

  function countUP(id, prev_data_attr) {
    setproductList(
      productList.map((p) =>
        p.id === id ? { ...p, data_attr: prev_data_attr + 1 } : p
      )
    );
  }

  function countDown(id, prev_data_attr) {
    setproductList(
      productList.map((p) =>
        p.id === id ? { ...p, data_attr: prev_data_attr - 1 } : p
      )
    );
  }
  const history = useHistory()
const [allcartproducts, setallcartproducts] = useState([])
const [purchseid, setpurchseid] = useState('')
const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
const [Purchasesavess, setPurchasesavess] = useState(false)
const [dailoa1, setdailoa1] = useState(false)
const [allproductslists, setallproductslists] = useState([])
const [qtyval, setqtyval] = useState('1')
const classes = useStyles();
const [pricevalue, setpricevalue] = useState('')
const [modal, setModal] = useState(false)
const [indexalueofupdate, setindexalueofupdate] = useState('')
const [Productonecollect, setProductonecollect] = useState([])
const [sgstper, setsgstper] = useState('')
const [salesrate, setsalesrate] = useState('')
const [proid, setproid] = useState('')
const [vatper, setvatper] = useState('')
const [uomdesc, setuomdesc] = useState('')
const [cgstper, setcgstper] = useState('')
const [taxid, settaxid] = useState('')
const [purchaseqtys, setpurchaseqtys] = useState('1')
const [totalqty, settotalqty] = useState('')
const [TOtaligstamt, setTOtaligstamt] = useState('')
const [deleteModal, setDeleteModal] = useState(false)
const [deletid, setdeletid] = useState('')
const [delteprods, setdelteprods] = useState(false)
const [updatenetamt, setupdatenetamt] = useState('')

const [productnames, setproductnames] = useState('')
const [provalue, setprovalue] = useState([])
const [uomid, setuomid] = useState('')
const [conqty, setconqty] = useState('')
const [discountper, setdiscountper] = useState('')
const [gstper, setgstper] = useState('')
const [sgstid, setsgstid] = useState('')

const [cgstpercentages, setcgstpercentages] = useState('')
const [igstper, setigstper] = useState('')
const [produpdata, setprodupdata] = useState(false)
var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
const [onsupplierinfo, setonsupplierinfo] = useState([])
const [prodimage, setprodimage] = useState('')
const [purchasegetone, setpurchasegetone] = useState([])
const [purchsdtlid, setpurchsdtlid] = useState('')
const [igstid, setigstid] = useState('')
const [purchaseupdatesmessage, setpurchaseupdatesmessage] = useState(false)
const [salesbillraised, setsalesbillraised] = useState('')
const [Mailtoggle, setMailtoggle] = useState(false)
 const [emailid, setemailid] = useState('')
const [qtyerrror, setqtyerrror] = useState(false)
useEffect(() => {
  Getallproductslistsss()
    ////////////console.log(localStorage.getItem('Carts'))
    let cartproducts = []
    let productofcart = JSON.parse(localStorage.getItem('Salescart'))
    //cartproducts.push()
setallcartproducts(productofcart)
if (props.match.params.id) {
  Getallsuppliervalue()
}else{
 
}
//Getonesupplier()
    }, [])
    const Mailtoogle = () => {
      if (Mailtoggle) {
        setMailtoggle(false);
        //setccmails('')
        //setInvoice(null);
      } else {
        setMailtoggle(true);
       // setccmails('')
      }
    };
   
    const SendMail  = async() => {
      ////////console.log(mailcontent.Buyer)
    
        const mail =  await axios.instance.post(`/salesmail` , 
      {
    username :localStorage.getItem('EmailId'),
    tomail:emailid,
    sub:"Sales Order",
   
    host:localStorage.getItem('SMTPServer'),
    port:localStorage.getItem('smtpport'),
  // --Factorycontactperson :"test",
    password:localStorage.getItem('mailpassword'),
    Companyname:localStorage.getItem('companyName'),
    loginname:localStorage.getItem('UserName'),
    // CcMail : "thanigakotti@gmail.com"
    
  },
      
      
     { headers: {'Authorization':tokent,
       'Content-Type': 'application/json'}}).then((res) => {
      if(res.status === 200) {
          toastr.success('Mail Sent Successfully', 'Sales Order')
      }else {
        toastr.error('Something went wrong ', 'Sales Order')
      }
     
       })
       Mailtoogle()
    
    }  
    const Getallproductslistsss = async() => {
      const get= await axios.instance.get('/Getallproducts',{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        


  setallproductslists(res.data)
      })
      }


const checkoutss = () => {
  setdailoa1(true)
setTimeout(() => {
  history.push('/Sales-OrderCheckout')
  setdailoa1(false)
}, 3000);
}
const checkoutss1 = () => {
  Updatepurchaseorderhdrs()

  setdailoa1(true)
  setpurchaseupdatesmessage(true)
setTimeout(() => {
  history.push('/My-Sales-Orders')
  setdailoa1(false)
}, 3000);
}


const onClickDelete = user => {
  setdeletid(user.Product_Details_Id)
  setDeleteModal(true)

}

const Updateget =  async(id, id1)  => {
  //////////console.log(id, id1)
  setindexalueofupdate(id1)
  setProductonecollect([])
// setvisible(true)
// setVisiblespinner(true)
// setTimeout(() => {
// setVisiblespinner(false)
// }, 2000);
 const datavalue  =  allcartproducts.filter(a => a.Product_Details_Id  === id)
 setProductonecollect(datavalue)
 //////////console.log('test',datavalue)
 for(const data of datavalue) {
   ////////console.log('datssss',data.Product_Details_Id)
setgstper(data.GSTPer)
  setuomid(data.UOM_Id)
   setqtyval(data.Order_Qty)
 setpricevalue(data.Rate)
 setsgstper(data.SGSTPer)
 setsalesrate(data.Sales_Rate)
 setproid(data.Product_Details_Id)
 setvatper(data.VAT_Percentage)
 setupdatenetamt(data.Amount)
 setproductnames(data.Product_Details_Description)
 setuomdesc(data.UOM_Description)
 setcgstpercentages(data.CST_Percentage)
 settaxid(data.TaxId)
setsgstid(data.SGSTId)
setigstid(data.IGSTId)
setigstper(data.IGSTPer)
setprodimage(data.Imagepath)
 ////////console.log('updd',data)
 }

}





const updateproduct =  async()  => {
  if(qtyval !=0) {

 
  let product = []
  let productsvalue = localStorage.getItem('Salescart')
  ////////console.log(proid)
  //////////////console.log(items)
  // ////////////console.log(items != null  )
  if( productsvalue != null  ) {
  const getdata = JSON.parse(productsvalue) 
  for(const data of getdata){
 
  product.push(data)
  
  }
  
  }
  ////////////console.log(parseInt( updatedqty))
  //const totlaamoutns =   localStorage.getItem('Total_Amount')
  //////////console.log('gstsss',gstper)
 const updateddatevalue = {
  
  //   Product_Details_Description: productnames,
  //   Product_Id: proid,
  //   UOM_Id:uomid,
  //   Order_Qty:qtyval,
  //   Rate: pricevalue,
  //   CST_Percentage: cgstper === '' ? 0 : cgstper,
  //   VAT_Percentage: vatper === '' ? 0 : vatper,
  //   Discount_Percentage: 0,
  //   RateinAED: 0,
  //   TaxId: "0",
  //   UOMType: 'P',
  //   DisAmt: 0,
  //   ExciseId: 0,
  //   ExcisePer: 0,
  //   OtherDesc: '',
  //   GSTPer: gstper,
  //   SGSTId: sgstid,
  //   SGSTPer: sgstper,
  //   IGSTId: 0,
  //   IGSTPer: igstper,
  //   PriUOM_Id:uomid ,
  //   PriOrder_Quantity: qtyval,
  //    PriRate: 0,
  //   ConQty: qtyval,
  //   Act_UOM: uomid,
  //   Act_Rate: 0,
  //   Act_Qty:qtyval,
  //   Sec_UomId: 0,
  // UOMtype: "P",
  // Imagepath:prodimage,
  // Amount:0,
  // PoSlNo:1
  
  Product_Details_Description: productnames,
  // PO_Id:localStorage.getItem('Purid'),
  Product_Details_Id:proid,
  UOM_Id:uomid,
   Order_Qty:parseFloat(qtyval),
   Rate:parseFloat(pricevalue),
   CST_Percentage:0 ,  
   VAT_Percentage:vatper === '' ? 0 : vatper ,
   Discount:0,
   Amount:0,
   Update_DC_Qty:0,
   update_sales_bill_qty:1,
   PoSlNo:1,
   OtherDesc:1,
   TaxId:taxid,  
   PriUOM_Id:uomid,
   GSTPer:parseFloat(gstper) === '' ? 0 : parseFloat(gstper),
   SGSTId:sgstid,
   SGSTPer:parseFloat(sgstper)  === '' ? 0 : parseFloat(sgstper),
   IGSTId:igstid,
   IGSTPer:igstper,
   PriUOM_Id:uomid,
   PriOrder_Quantity:parseInt(qtyval),
   PriRate:parseFloat(pricevalue),
   ConQty:qtyval,
   Act_UOM:uomid,
   Act_Rate:parseFloat(pricevalue),
   Act_Qty:qtyval,
   DisAmt:0,
   Sec_UomId:uomid,
   Imagepath:prodimage,
   UOMtype:"P",
   DutyPer:0,
   Duty_Id:0,
   Lpo_Id:0
  



















   }
     product[indexalueofupdate]  =  updateddatevalue
  //////////console.log('check',indexalueofupdate)
 localStorage.setItem('Salescart',  JSON.stringify(product))
  let Getprod =  localStorage.getItem('Salescart')
  // setprovalue(Getprod)
  const getdelteddate =  localStorage.getItem('Salescart')
  let removeproducts = JSON.parse(getdelteddate)
  ////////////console.log(removeproducts)
  setallcartproducts(removeproducts)
  let qtytotal = []
  
  for(const data of removeproducts){
  qtytotal.push(parseFloat(data.Order_Qty))
  }
  var qtyvalue = 0 
  for (let i = 0; i < qtytotal.length; i++) {
    qtyvalue += qtytotal[i];
  }
  settotalqty(qtyvalue)
  localStorage.setItem('TotalQty1',qtyvalue)
  
  let taxtotal = []
  for(const data of removeproducts) {
  taxtotal.push(parseFloat(data.GSTPer))  
  }
  var taxvalue = 0
  for(let i =0; i< taxtotal.length; i++) {
  taxvalue += taxtotal[i]
  }
  localStorage.setItem('taxvalue1',taxvalue)
  //AsyncStorage.setItem('Toataltax', taxvalue.toString())
  let  totalnetamount = []
  for(const data of removeproducts) {
    totalnetamount.push(parseFloat(data.Rate * data.Order_Qty))
  }
  var totalnetcount = 0
  for(let i =0; i< totalnetamount.length; i++) {
    totalnetcount += totalnetamount[i]
  }
  //settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  //localStorage.setItem('Totalsumamounts1',totalnetcount)
  
  
  localStorage.setItem('Totalsumamounts1',totalnetcount)
 
  let totalIgstamt = []
  for(const data of removeproducts) {
  totalIgstamt.push(parseFloat((data.Rate * data.Order_Qty) * data.GSTPer/100))
  ////////////console.log('igst', data.IGSTPer)
  }
  var  totalIgstvalu = 0
  for(let i=0; i< totalIgstamt.length; i++) {
  totalIgstvalu +=totalIgstamt[i]
  }
  localStorage.setItem('Totaligstvalue1',totalIgstvalu)

  ////////////console.log(totalIgstvalu)
  //settotaltax(totalcgstvalu +totalcgstvalu)
  setTOtaligstamt(totalIgstvalu)
  
  //settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  //localStorage.setItem('Totalsumamounts1',totalnetcount)

  let totalsalesrate = []
for(const data of removeproducts) {
  //////console.log(data,'datasss')
  totalsalesrate.push(parseFloat((((((data.Rate)/(100 + data.GSTPer)*100)))* parseFloat(data.Order_Qty))))
}
var totalsalescount = 0
for(let i =0; i< totalsalesrate.length; i++) {
  totalsalescount += totalsalesrate[i]
}
//settotalamt(totalnetcount)
//AsyncStorage.setItem('Totalamt', totalnetcount.toString())
//localStorage.setItem('Totalsumamounts1',totalnetcount)

//////console.log(totalsalescount,'counts')
localStorage.setItem('totalsalesrate',totalsalescount)

  
  let totalsalesigstvaleu = []
  for(const data of removeproducts) {
    totalsalesigstvaleu.push(parseFloat((totalsalescount * data.GSTPer)/100))
  //////console.log('igst', data.IGSTPer)
  //////console.log('test', data.GSTPer)
  }
  var  totalsalesamt = 0
  for(let i=0; i< totalsalesigstvaleu.length; i++) {
    totalsalesamt +=totalsalesigstvaleu[i]
  }
  localStorage.setItem('totalsalesgstamt',totalsalesamt)





  //let prodvalues = JSON.parse(Getprod)
  ////////////console.log(prodvalues)
  //setprovalue(prodvalues)
  ////////////console.log('updatedata',localStorage.getItem('Carts'))
  setModal(false)

  setdailoa1(true)
  setTimeout(() => {
    setdailoa1(false)
    setprodupdata(true)
  }, 3000);
}else{
setqtyerrror(true)
setTimeout(() => {
  setqtyerrror(false)
}, 2000);
}
  }
const toggle = () => {
  if (modal) {
    setModal(false)
   // setUser(null)
  
  } else {
    setModal(true)
  }

}

const handleUserClick = (arg,index) => {
  //////////console.log(arg)

  //setIsEdit(true)
if(props.match.params.id) {
 Getpurchaseorderdetils()
 setqtyval(arg.Order_Qty)
 setpricevalue(arg.Rate)
 setpurchsdtlid(arg.Order_Dtl_ID)
} else {
  Updateget(arg.Product_Details_Id,index)
  setpricevalue(arg.Rate)

}
// if(!props.match.params.id) {
//   Updatepurchseorderdts()
// } else{

// }
  toggle()
}

const deleteproduct  =  async(id) => {
 
// setdailoa1(true)
 setTimeout(() => {
  setdailoa1(false)

 }, 2000);
 setDeleteModal(true)

  let productsvalue = localStorage.getItem('Salescart')
  var items = JSON.parse(productsvalue)
  // ////////////console.log(items)
  for (var i =0; i< items.length; i++) {
  // var items = JSON.parse(items[i]);
  //////////////console.log(items[i].Product_Id)
  if (items[i].Product_Details_Id == id) {
   const deletedata =  items.splice(i, 1);
   //////////////console.log(deletedata)
  }
  
  }
  //////////////console.log(items)
  let  prod = JSON.stringify(items);
  //console.log(prod,'pss')
  localStorage.setItem('Salescart', prod)
  const getdelteddate =  localStorage.getItem('Salescart')
  
  let removeproducts = JSON.parse(getdelteddate)
  
  localStorage.setItem('Salescartcount',removeproducts.length)
  setallcartproducts(removeproducts)
  //console.log(removeproducts,'remo')
  const indexofnum =removeproducts.map((items, index) => ({index, ...items}))
  let qtytotal = []
  
  for(const data of removeproducts){
    qtytotal.push(parseFloat(data.Order_Qty))

  }
  var qtyvalue = 0 
  for (let i = 0; i < qtytotal.length; i++) {
    qtyvalue += qtytotal[i];
  }

  settotalqty(qtyvalue)
  localStorage.setItem('TotalQty1',qtyvalue)
  
  let taxtotal = []
  for(const data of removeproducts) {
  taxtotal.push(parseFloat(data.GSTPer))
  }
  var taxvalue = 0
  for(let i =0; i< taxtotal.length; i++) {
  taxvalue += taxtotal[i]
  }
  localStorage.setItem('taxvalue1',taxvalue)
  //AsyncStorage.setItem('Toataltax', taxvalue.toString())
  let  totalnetamount = []
  for(const data of removeproducts) {
    totalnetamount.push(parseFloat(data.Rate * data.Order_Qty ))
  }
  var totalnetcount = 0
  for(let i =0; i< totalnetamount.length; i++) {
    totalnetcount += totalnetamount[i]
  }
  localStorage.setItem('Totalsumamounts1',totalnetcount)
 // settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  
  
  
  let totalIgstamt = []
  for(const data of removeproducts) {
  totalIgstamt.push(parseFloat((data.Rate * data.Order_Qty) * data.GSTPer/100))
  ////////////console.log('igst', data.IGSTPer)
  }
  var  totalIgstvalu = 0
  for(let i=0; i< totalIgstamt.length; i++) {
  totalIgstvalu +=totalIgstamt[i]
  }
  
  
  let  totalsalesrate = []
  for(const data of removeproducts) {
    totalsalesrate.push(parseFloat(((((data.Rate)/(100 + data.GSTPer)*100))* parseFloat(data.Order_Qty))))
  }
  var totalsalescount = 0
  for(let i =0; i< totalsalesrate.length; i++) {
    totalsalescount += totalsalesrate[i]
  }
  //console.log(totalsalescount,'countsofsales')
  //settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  //localStorage.setItem('Totalsumamounts1',totalnetcount)
  
  
  localStorage.setItem('totalsalesrate',totalsalescount)
  ////////console.log(totalsalescount)
  //settotalamt(totalnetcount)
  //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
  //localStorage.setItem('Totalsumamounts1',totalnetcount)
  
  let totalsalesigstvaleu = []

  for(const data of removeproducts) {
    //console.log(data.GSTPer,totalsalescount,data.GSTPer * totalsalescount/100,'ddtd')
    totalsalesigstvaleu.push(parseFloat((parseFloat(((((data.Rate)/(100 + data.GSTPer)*100))* parseFloat(data.Order_Qty)))) * data.GSTPer)/100)
  ////////////console.log('igst', data.IGSTPer)
  ////////console.log('test', data.GSTPer)
  }
  var  totalsalesamt = 0
  for(let i=0; i< totalsalesigstvaleu.length; i++) {
    totalsalesamt +=totalsalesigstvaleu[i]
  }
  //console.log(totalsalesamt,'totalsalesss')
  localStorage.setItem('totalsalesgstamt',totalsalesamt)
  
  
  
  //////////console.log(totalIgstvalu)
  //settotaltax(totalcgstvalu +totalcgstvalu)
  setTOtaligstamt(totalIgstvalu)
  localStorage.setItem('Totaligstvalue1',totalIgstvalu)
  ////////////console.log(  
    //localStorage.removeItem('Salescartcount')
  setDeleteModal(false)
  setdelteprods(true)
  }
 
const toggledeletemodal  = (id) => {
  setDeleteModal(true)
  setdeletid(id)
 

}
const Getallsuppliervalue = async() => {
  const get= await axios.instance.get(`/Getonesalesorderdetail/${props.match.params.id}`,{ headers: {'Authorization':tokent,
  'Content-Type': 'application/json',
  
  }}).then((res) => {
    
  
    setpurchasegetone(res.data)
    for(const data of res.data){
      setsalesbillraised(data.update_sales_bill_qty)
    }
    var getoneprodctsofpurchse = res.data
    
  // //////console.log('',getoneprodctsofpurchse)
    localStorage.setItem('Salescart',JSON.stringify(getoneprodctsofpurchse))
    let qtytotal = []
  
    for(const data of res.data){
    qtytotal.push(parseFloat(data.Order_Qty))
    }
    var qtyvalue = 0 
    for (let i = 0; i < qtytotal.length; i++) {
      qtyvalue += qtytotal[i];
    }
    settotalqty(qtyvalue)
    localStorage.setItem('TotalQty1',qtyvalue)
    
    let taxtotal = []
    for(const data of res.data) {
    taxtotal.push(parseFloat(data.GSTPer))  
    }
    var taxvalue = 0
    for(let i =0; i< taxtotal.length; i++) {
    taxvalue += taxtotal[i]
    }
    localStorage.setItem('taxvalue1',taxvalue)
    //AsyncStorage.setItem('Toataltax', taxvalue.toString())
    let  totalnetamount = []
    for(const data of res.data) {
      totalnetamount.push(parseFloat(data.Rate * data.Order_Qty))
    }
    var totalnetcount = 0
    for(let i =0; i< totalnetamount.length; i++) {
      totalnetcount += totalnetamount[i]
    }
    //settotalamt(totalnetcount)
    //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
    //localStorage.setItem('Totalsumamounts1',totalnetcount)
    
    
    localStorage.setItem('Totalsumamounts1',totalnetcount)
   
    let  totalsalesrate = []
    for(const data of res.data) {
      totalsalesrate.push(parseFloat(((((data.Rate)/(100 + data.GSTPer)*100))* parseFloat(data.Order_Qty))))
    }
    var totalsalescount = 0
    for(let i =0; i< totalsalesrate.length; i++) {
      totalsalescount += totalsalesrate[i]
    }
    //settotalamt(totalnetcount)
    //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
    //localStorage.setItem('Totalsumamounts1',totalnetcount)
    
    
    localStorage.setItem('totalsalesrate',totalsalescount)
   









    let totalIgstamt = []
    for(const data of res.data) {
    totalIgstamt.push(parseFloat((data.Rate * data.Order_Qty) * data.GSTPer/100))
    ////////////console.log('igst', data.IGSTPer)
    }
    var  totalIgstvalu = 0
    for(let i=0; i< totalIgstamt.length; i++) {
    totalIgstvalu +=totalIgstamt[i]
    }
    localStorage.setItem('Totaligstvalue1',totalIgstvalu)
  


    let totalsalesigstvaleu = []
    for(const data of  res.data) {
      totalsalesigstvaleu.push(parseFloat((totalsalescount * data.GSTPer)/100))
    ////////////console.log('igst', data.IGSTPer)
    ////////console.log('test', data.GSTPer)
    }
    var  totalsalesamt = 0
    for(let i=0; i< totalsalesigstvaleu.length; i++) {
      totalsalesamt +=totalsalesigstvaleu[i]
    }
    localStorage.setItem('totalsalesgstamt',totalsalesamt)
  

    //////////console.log(totalIgstvalu)
    //settotaltax(totalcgstvalu +totalcgstvalu)
    setTOtaligstamt(totalIgstvalu)
  })
  }


  const Getpurchaseorderdetils = async() => {
    const get= await axios.instance.get(`/Getonesalesorderdetail/${props.match.params.id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      for(const data of res.data) {
        setqtyval(parseFloat(data.Order_Qty))
        setpricevalue(data.Rate)
       // setpurchsdtlid(data.Order_Dtl_ID)
        setsalesbillraised(data.update_sales_bill_qty)
      }
    
      // setpurchasegetone(res.data)
      // let qtytotal = []
    
      // for(const data of res.data){
      // qtytotal.push(parseInt(data.Order_Quantity))
      // }
      // var qtyvalue = 0 
      // for (let i = 0; i < qtytotal.length; i++) {
      //   qtyvalue += qtytotal[i];
      // }
      // settotalqty(qtyvalue)
      // localStorage.setItem('TotalQty1',qtyvalue)
      
      // let taxtotal = []
      // for(const data of res.data) {
      // taxtotal.push(parseFloat(data.GSTPer))  
      // }
      // var taxvalue = 0
      // for(let i =0; i< taxtotal.length; i++) {
      // taxvalue += taxtotal[i]
      // }
      // localStorage.setItem('taxvalue',taxvalue)
      // //AsyncStorage.setItem('Toataltax', taxvalue.toString())
      // let  totalnetamount = []
      // for(const data of res.data) {
      //   totalnetamount.push(parseFloat(data.Rate))
      // }
      // var totalnetcount = 0
      // for(let i =0; i< totalnetamount.length; i++) {
      //   totalnetcount += totalnetamount[i]
      // }
      // //settotalamt(totalnetcount)
      // //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
      // //localStorage.setItem('Totalsumamounts1',totalnetcount)
      
      
      // localStorage.setItem('Totalsumamounts1',totalnetcount)
     
      // let totalIgstamt = []
      // for(const data of res.data) {
      // totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
      // ////////////console.log('igst', data.IGSTPer)
      // }
      // var  totalIgstvalu = 0
      // for(let i=0; i< totalIgstamt.length; i++) {
      // totalIgstvalu +=totalIgstamt[i]
      // }
      // localStorage.setItem('Totaligstvalue1',totalIgstvalu)
    
      // ////////////console.log(totalIgstvalu)
      // //settotaltax(totalcgstvalu +totalcgstvalu)
      // setTOtaligstamt(totalIgstvalu)
    })
    }
    const Updatepurchseorderdts = async() => {
     if(qtyval !=0){

   
    ////////console.log("test",purchsdtlid )
  
      const create  = await axios.instance.put(`/updatesalesorderdtl/${purchsdtlid}`, {
   
        Order_Qty:qtyval,
    
       
        PriOrder_Quantity:qtyval,
        PriRate:pricevalue,
        Amount: pricevalue* qtyval,
      
        Act_Qty:qtyval
        
       
   
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        ////////console.log('header', res.data)
        toggle()
        Getallsuppliervalue()
        setprodupdata(true)
      
       })
      }else{
        setqtyerrror(true)
        setTimeout(() => {
          setqtyerrror(false)
        }, 2000);
      }
  }


  const Updatepurchaseorderhdrs = async() => {
     
    //////console.log("test",props.match.params.id,localStorage.getItem('Salescart') )
  
      const create  = await axios.instance.put(`/Updatesalesorderhdr/${props.match.params.id}`, {
        Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts1')),

        VAT_Amount:  localStorage.getItem('statecode') === '33' ? parseFloat(localStorage.getItem('Totaligstvalue1'))/2 : 0,
        CST_Amount:0,
        Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts1')) +parseFloat(localStorage.getItem('Totaligstvalue1')),
        IGSTAmt:localStorage.getItem('statecode') === '33' ? 0 : parseFloat(localStorage.getItem('Totaligstvalue1')),
        SGSTAmt:localStorage.getItem('statecode') === '33' ?   parseFloat(localStorage.getItem('Totaligstvalue1'))/2:0
      
      
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        ////////console.log('header',localStorage.setItem('Salescart'))
        //toggle()
      // Getallsuppliervalue()
        setprodupdata(true)
        localStorage.setItem('salesedit','false')
        
        localStorage.setItem('Salescart', JSON.stringify([]));
        localStorage.removeItem('TotalQty1');
        localStorage.removeItem('taxvalue1');
        localStorage.removeItem('Totalsumamounts1')
      
        localStorage.removeItem('Totaligstvalue1')
    localStorage.removeItem('totalsalesgstamt')
    
     
       })
  }




  const Updatesalesorderhedd = async() => {
     
    ////////console.log("test",purchsdtlid )
  
      const create  = await axios.instance.put(`/Updatesalesorderhdr/${parseInt(localStorage.getItem('saleseditid'))}`, {
        Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts1')),

        VAT_Amount:  localStorage.getItem('statecode') === '33' ? parseFloat(localStorage.getItem('Totaligstvalue1'))/2 : 0,
        CST_Amount:0,
        Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts1')) +parseFloat(localStorage.getItem('Totaligstvalue1')),
        IGSTAmt:localStorage.getItem('statecode') === '33' ? 0 : parseFloat(localStorage.getItem('Totaligstvalue1')),
        SGSTAmt:localStorage.getItem('statecode') === '33' ?   parseFloat(localStorage.getItem('Totaligstvalue1'))/2:0
      
      
      },{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        //////console.log('header1', res.data)
        //toggle()

        Getallsuppliervalue()
        setprodupdata(true)
       
       })
       Createpurchaseorder()
  }

  const Deletepurchaseorder = async() => {
    ////////console.log('testdetel',deletid)
    const createHoliday =  await axios.instance.delete(`/DeleteSalsedtl/${parseInt(localStorage.getItem('saleseditid'))}`, { headers: {'Authorization':tokent,
    'Content-Type': 'application/json'}}).then((Res) => {
     

      ////////console.log(Res.data)
     // Getbuyerorders()
      
     
     
      
    })
  }
  const Createpurchaseorder = async() => {
   
    Deletepurchaseorder()
 
     // setdailoa1(true)
     

    
      const  details = localStorage.getItem('Salescart')
      const Orderid =   localStorage.getItem('Salid')
      let product =  JSON.parse(details)
      for(const data of product){
        //////console.log('prr',data)
        //////console.log(data.Product_Details_Id)
        const productcoll = Object.assign({
          Order_Id:localStorage.getItem('saleseditid'),
          Product_Id:data.Product_Details_Id,
          UOM_Id:data.UOM_Id,
          Order_Qty:data.Order_Qty,
          Rate:data.Rate,
          CST_Percentage:0,
          VAT_Percentage:localStorage.getItem('statecode') === '33' ? data.VAT_Percentage:0,
          Discount:0,
          Amount:(data.Rate)*(data.Order_Qty)
          ,PoSlNo:0,        
      OtherDesc:0,
      TaxId:data.TaxId,
      PriUOM_Id:data.UOM_Id,
      PriOrder_Quantity:data.Order_Qty,
      PriRate:data.Rate,
      ConQty:data.Order_Qty,
      Act_UOM:data.UOM_Id,
      Act_Rate:data.Rate,
      Act_Qty:data.Order_Qty,
      DisAmt:0,
      DutyPer:0,
      Duty_Id:0,
      Lpo_Id:0,
      Sec_UomId:data.UOM_Id,    
      GSTPer:data.GSTPer,
      SGSTId: localStorage.getItem('statecode') === '33'  ? data.SGSTId :0,
      SGSTPer:localStorage.getItem('statecode') === '33' ? data.SGSTPer:0,
      IGSTId:localStorage.getItem('statecode') === '33' ? 0: data.IGSTId,
      IGSTPer:localStorage.getItem('statecode') === '33' ? 0:data.IGSTPer
        }
          , {Order_Id: parseInt(Orderid),OpType:'New'})
    const Dtl  =  await axios.instance.post(`/Insertsalesorderdtl`,productcoll
    
    
    ,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
     
      },method:"post"}).then((res) => {
        //////console.log( 'details', res.data)

      
        localStorage.removeItem('TotalQty1');
        localStorage.removeItem('taxvalue1');
        localStorage.removeItem('Totalsumamounts1')
        localStorage.setItem('salesedit','false')
        localStorage.removeItem('Totaligstvalue1')
    localStorage.removeItem('totalsalesgstamt')
         localStorage.removeItem('Salescartcount')
         localStorage.setItem('Salescart', JSON.stringify([]));
      localStorage.setItem('Salescartcount',0)
   
    })
  //  SendMail()
    setTimeout(() => {
      setdailoa1(false)
     // setsupperror(false)
    }, 2000);
  
    setPurchasesavess(true)
setTimeout(() => {
  history.push('/Salesorder')
 // setsupperror(false)
}, 3000);
  
    }
  
    
       
  }
  
  const Getonesupplier = async() => {
    const get= await axios.instance.get(`/Getonecustomer/${localStorage.getItem('custemailid')}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      
    

setonsupplierinfo(res.data)
for(const data of res.data){
setemailid(data.EmailId)

}
    })
    }

  
  return (
    <React.Fragment>
        <DeleteModal
        show={deleteModal}
        onDeleteClick={()=> deleteproduct(deletid)}
        onCloseClick={() => setDeleteModal(false)}
      />
      {props.match.params.id ? (
      <div className="page-content">
        <Container fluid>
          {localStorage.getItem('salesview')=== 'Y' ? (
          <Breadcrumbs title="Sales Order" breadcrumbItem="View Sales Order" />
          ):  <Breadcrumbs title="Sales Order" breadcrumbItem="Cart" />}
{purchasegetone !=null ? (
          <Row className="mb-3">
            <Col xl="8">

              {purchasegetone.map((data, index) => (
                <Card className="border shadow-none" key={data.Product_Details_Id}>
                  <CardBody>
                    <div className="d-flex align-items-start border-bottom pb-3">
                      <div className="flex-shrink1 me-4  hover14 column">
                        <figure>
                      <img src={`${data.Imagepath}`} 
 style={{width:'200px', height:'200px'}}
  alt="" className="img-fluid mx-auto d-block"
  onError={({ currentTarget }) => {
    currentTarget.onerror = null; // prevents looping
    currentTarget.src=imageDefault;
  }}
   
  /> 
  </figure>
                      </div>
                      <div className="flex-grow-1 align-self-center overflow-hidden">
                        <div>
                          <h5 className="text-truncate font-size-16">
                         
                              {data.Product_Details_Description}
                         
                          </h5>
                      
                        </div>
                      </div>
                      <div className="ml-2">
                        <ul className="list-inline mb-0 font-size-16">
                        <li className="list-inline-item">
                       {localStorage.getItem('salesbillraised') && localStorage.getItem('salesview') === 'Y' ? (
                          
                                null
                                ):   
                                <Link to="#" className="text-muted px-2" onClick={()=>handleUserClick(data,index)}>
                          
                                <i className="uil uil-pen font-size-16"></i>
                                
                                </Link> }
                        
                          </li>{" "}
                          {/* <li className="list-inline-item">
                            <Link to="#" className="text-muted px-2" onClick={() => toggledeletemodal(data.Product_Details_Id)}>
                              <i className="uil uil-trash-alt"></i>
                            </Link>{" "}
                          </li>{" "} */}
                          {/* <li className="list-inline-item">
                            <Link to="#" className="text-muted px-2">
                              <i className="uil uil-heart"></i>
                            </Link>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                    <div>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="mt-3">
                            <p className="text-muted mb-2">Net Rate</p>
                            
                            <h5 className="font-size-16">₹ {numeral(data.Rate).format('0,0.00')}  </h5>
                          </div>
                        </div>
                     
                        <div className="col-md-2">
                          <div className="mt-3">
                            <p className="text-muted mb-2"> Sales Rate</p>
                            
                            <h5 className="font-size-16">₹ {numeral((data.Rate)/(100 + data.GSTPer)*100).format('0,0.00')}  </h5>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="mt-3">
                            <p className="text-muted mb-2">Quantity</p>
                            <div
                            
                           
            >
                           {/* /// <Input type="number"  value={qtyval} onChange={(e)=>setqtyval(e.target.value)} /> */}
                            <h5 className="font-size-16">{parseFloat(data.Order_Qty)}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="mt-3">
                            <p className="text-muted mb-2">Total</p>
                            <h5 className="font-size-16">₹ {numeral(numeral(((data.Rate)/(100 + data.GSTPer)*100)).format('0,0.00') * parseFloat(data.Order_Qty)).format('0,0.00')}</h5>
                           
                            </div>
                          </div>
                          <div className="col-md-2">
                          <div className="mt-3">
                            {/* <p className="text-muted mb-2">Quantity</p> */}
                            <div
                            
                           
            >
                          <p className="text-muted mb-2">GST % </p>
                            <h5 className="font-size-16 text-centered">{data.GSTPer}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
       <p className="text-muted mb-2">GST Amount </p>
       <h5 className="font-size-16 text-centered">{numeral((data.Order_Qty * (data.Rate)/(100 + data.GSTPer)*100) * (data.GSTPer)/100).format('0,0.00') }</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              ))}
              <Row className="mt-4">
                                    <Col sm={6}>
                                     {localStorage.getItem('salesbillraised') && localStorage.getItem('salesview') === 'Y' ? (
                                        null ):
                                       <Link to="/Salesorder" className="btn btn-link text-muted">
                                       <i className="uil uil-arrow-left me-1"></i> Continue Shopping </Link>
                                       
                                    
                                   
                                     }
                                   </Col> 
                                    <Col sm={6}>
                                    {localStorage.getItem('salesbillraised') && localStorage.getItem('salesview') === 'Y' ? (
                                      null
                                      ): 
                                        <div className="text-sm-end mt-2 mt-sm-0">
                                            <Link to="#" className="btn btn-success" onClick={checkoutss1}>
                                               Update </Link>
                                        </div>
 }
                                    </Col> 
                                </Row>
            </Col>
            <Col xl="4">
              <div className="mt-5 mt-lg-0">
                <Card className="border shadow-none">
                  <div className="card-header bg-transparent border-bottom py-3 px-4">
                  <h5 className="font-size-16 mb-3 text-primary">
                     Price Details <span className="float-end"></span>
                    </h5>
              
                   
                  </div>
                  <CardBody className="p-4">
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <tbody>
                        <tr>
                            <td> Total Quantity :</td>
                            <td className="text-end">{parseFloat(localStorage.getItem('TotalQty1'))}</td>
                          </tr>
                          <tr>
                            <td>Gross Amount :</td>
                            <td className="text-end">₹{numeral((localStorage.getItem('totalsalesrate'))).format('0,0.00')}</td>
                          </tr>
                        
                       
                      
                          <tr>
                            <td>GST Amount : </td>
                            <td className="text-end"> ₹{numeral(localStorage.getItem('totalsalesgstamt')).format('0,0.00')}</td>
                          </tr>
                          <tr className="bg-light">
                            <th>Total :</th>
                            <td className="text-end">
                            <span className="fw-bold"> ₹ {numeral(parseFloat(localStorage.getItem('totalsalesrate'))+parseFloat(localStorage.getItem('totalsalesgstamt'))).format('0,0.00') }</span>
                          </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
          ): 
          
          <div> 
            <h3 className="text-primary text-center"> Your Cart is Empty</h3>
            </div>}
        </Container>
      </div>
      ) :  
      
      <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Sales Order" breadcrumbItem="Cart" />
{allcartproducts !=null ? (
        <Row className="mb-3">
          <Col xl="8">

            {allcartproducts.map((data, index) => (
              <Card className="border shadow-none" key={data.Product_Details_Id}>
                <CardBody>
                  <div className="d-flex align-items-start border-bottom pb-3">
                    <div className="flex-shrink1 me-4  hover14 column">
                      <figure>
                    <img src={`${data.Imagepath}`} 
style={{width:'200px', height:'200px'}}
alt="" className="img-fluid mx-auto d-block"
onError={({ currentTarget }) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src=imageDefault;
}}
 
/> 
</figure>
                    </div>
                    <div className="flex-grow-1 align-self-center overflow-hidden">
                      <div>
                        <h5 className="text-truncate font-size-16">
                       
                            {data.Product_Details_Description}
                       
                        </h5>
                    
                      </div>
                    </div>
                    <div className="ml-2">
                      <ul className="list-inline mb-0 font-size-16">
                      <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2" onClick={()=>handleUserClick(data,index)}>
                          <i className="uil uil-pen font-size-16"></i>
                          </Link>{" "}
                        </li>{" "}
                        <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2" onClick={() => toggledeletemodal(data.Product_Details_Id)}>
                            <i className="uil uil-trash-alt"></i>
                          </Link>{" "}
                        </li>{" "}
                        {/* <li className="list-inline-item">
                          <Link to="#" className="text-muted px-2">
                            <i className="uil uil-heart"></i>
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="row">
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Net Rate</p>
                          
                          <h5 className="font-size-16">₹ {numeral(data.Rate).format('0,0.00')}  </h5>
                        </div>
                        
                      </div>
                      <div className="col-md-2">
                          <div className="mt-3">
                            <p className="text-muted mb-2"> Sales Rate</p>
                            
                            <h5 className="font-size-16">₹ {numeral((data.Rate)/(100 + data.GSTPer)*100).format('0,0.00')}  </h5>
                          </div>
                        </div>
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Quantity</p>
                          <div
                          
                         
          >
                         {/* /// <Input type="number"  value={qtyval} onChange={(e)=>setqtyval(e.target.value)} /> */}
                          <h5 className="font-size-16">{parseFloat(data.Order_Qty)}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mt-3">
                          <p className="text-muted mb-2">Total</p>
                          <h5 className="font-size-16">₹ {numeral(numeral(((data.Rate)/(100 + data.GSTPer)*100)).format('0,0.00')* parseFloat(data.Order_Qty)).format('0,0.00')}</h5>
                         
                          </div>
                        </div>
                        <div className="col-md-2">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
                        <p className="text-muted mb-2">GST % </p>
                          <h5 className="font-size-16 text-centered">{data.GSTPer}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mt-3">
                          {/* <p className="text-muted mb-2">Quantity</p> */}
                          <div
                          
                         
          >
       <p className="text-muted mb-2">GST Amount </p>
       <h5 className="font-size-16 text-centered">{numeral((data.Order_Qty * (data.Rate)/(100 + data.GSTPer)*100) * (data.GSTPer)/100).format('0,0.00')}</h5>
                          
                          </div>
                          <div>
                         
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))}
            <Row className="mt-4">
                                  <Col sm={6}>
                              
                                      <Link to="/Salesorder" className="btn btn-link text-muted">
                                          <i className="uil uil-arrow-left me-1"></i> Continue Shopping </Link>
                                  </Col> 
                                  <Col sm={6}>
                                      {localStorage.getItem('salesedit') === 'true'  ? ( 
                                      <div className="text-sm-end mt-2 mt-sm-0">
                                          <Link to="#" className="btn btn-success" onClick={Updatesalesorderhedd}>
                                            Update</Link>
                                      </div>
                                      ):
                                      <div className="text-sm-end mt-2 mt-sm-0">
                                      {localStorage.getItem('Salescartcount') === '0' ? (
                                     null
                                 ):
                                 <Link to="#" className="btn btn-success" onClick={checkoutss}>
                                 <i className="uil uil-shopping-cart-alt me-1" ></i> Place Order </Link>
                                 }
                                 </div>
}
                                  </Col> 
                              </Row>
          </Col>
          <Col xl="4">
            <div className="mt-5 mt-lg-0">
              <Card className="border shadow-none">
                <div className="card-header bg-transparent border-bottom py-3 px-4">
                <h5 className="font-size-16 mb-3 text-primary">
                   Price Details <span className="float-end"></span>
                  </h5>
            
                 
                </div>
                <CardBody className="p-4">
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <tbody>
                      <tr>
                          <td> Total Quantity :</td>
                          <td className="text-end">{localStorage.getItem('TotalQty1')}</td>
                        </tr>
                        <tr>
                          <td>Gross Amount :</td>
                          <td className="text-end">₹ {numeral((localStorage.getItem('totalsalesrate'))).format('0,0.00')}</td>
                        </tr>
                      
                     
                    
                        <tr>
                          <td>GST Amount : </td>
                          <td className="text-end">₹ {numeral(localStorage.getItem('totalsalesgstamt')).format('0,0.00')}</td>
                        </tr>
                        <tr className="bg-light">
                          <th>Total :</th>
                          <td className="text-end">
                            <span className="fw-bold"> ₹ {numeral(parseFloat(localStorage.getItem('totalsalesrate'))+parseFloat(localStorage.getItem('totalsalesgstamt'))).format('0,0.00') }</span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
        ): 
        
        <div> 
          <h3 className="text-primary text-center"> Your Cart is Empty</h3>
          </div>}
      </Container>
    </div> } {props.match.params.id   ? (
      <Modal isOpen={modal} toggle={toggle} size="sm">
            <ModalHeader toggle={toggle} tag="h4">
            { "Update  Product"}
            </ModalHeader>
            <ModalBody>
              <Form
              
              >
                <Row>
                                {/* <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                      Price
                                </Label>
                                <Input
                                type="number"
                                name="Date"
                              value={pricevalue}
                              onChange={(e)=> setpricevalue(e.target.value)}
                              
                              />
                  
                             
                                  </div>
                                </Col> */}
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                      Quantity
                                </Label>
                                <Input
                                type="number"
                                name="Order_Quantity"
                              value={qtyval}
                            
                              onChange={(e)=>
                                {
                                  if(e.target.value.length <=7 ){
                                    setqtyval(e.target.value)}  
                                  }
                                }
                                                          
                              />
                                                    {qtyerrror ? <p  style={{fontSize:"12px"}} className="error">Please Enter Valid Quantity </p> :  null}

                                  </div>
                                </Col>
                              </Row>
                <Row>
                  <Col>
                     <div className="text-end">
                       {!props.match.params.id ? (
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                   
onClick={(e)=> {
  e.preventDefault()
  updateproduct()
}}
                      
                        
                      >
                        Update
                      </button>
                      ):    
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                          onClick={(e)=> {
                            e.preventDefault()
                            Updatepurchseorderdts()
                          }}      
                        >
                          Update
                        </button>}
                    </div>
                  
               
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
          ):   <Modal isOpen={modal} toggle={toggle} size="sm">
          <ModalHeader toggle={toggle} tag="h4">
          { "Update  Product"}
          </ModalHeader>
          <ModalBody>
            <Form
            
            >
              <Row>
                              {/* <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    Price
                              </Label>
                              <Input
                              type="number"
                              name="Date"
                            value={pricevalue}
                            onChange={(e)=> setpricevalue(e.target.value)}
                            
                            />
                
                           
                                </div>
                              </Col> */}
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    Quantity
                              </Label>
                              <Input
                              type="number"
                              name="Order_Quantity"
                            value={qtyval}
                            onChange={(e)=>
                              {
                              if(e.target.value.length<=6){

                            
                              setqtyval(e.target.value)}
                            }}                             
                            />
                                                                    {qtyerrror ? <p style={{fontSize:"12px"}}  className="error">Please Enter Valid Quantity </p> :  null}

                                </div>
                              </Col>
                            </Row>
              <Row>
                <Col>
                   <div className="text-end">
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                 
onClick={(e)=> {
e.preventDefault()
updateproduct()
}}
                    
                      
                    >
                      Update
                    </button>
                  </div>
                
             
                </Col>
              </Row>
            </Form>
          </ModalBody>
        </Modal>}
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Sales Order Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
 {produpdata ? (
                    <SweetAlert
                      title="Product Updated  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setprodupdata(false);
                      }}
                    ></SweetAlert>
                  ) : null}


{purchaseupdatesmessage ? (
                    <SweetAlert
                      title="Sales Updated  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setpurchaseupdatesmessage(false);
                      }}
                    ></SweetAlert>
                  ) : null}

{ delteprods? (
                    <SweetAlert
                      title="Product Deleted  Successfully "
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setdelteprods(false);
                      }}
                    ></SweetAlert>
                  ) : null}
    </React.Fragment>
  );
};

export default EcommerceCart;
